import PropTypes from "prop-types";

import { HistoryEdu, HomeWork } from "@styled-icons/material-rounded";
import { Home, HomeAlt } from "@styled-icons/boxicons-regular";
import { Home as HomeSolid } from "@styled-icons/boxicons-solid";

function CaseIcon({ type, size }) {
  switch (type) {
    case "buying":
      return <HomeSolid size={size} />;
    case "selling":
      return <Home size={size} />;
    case "remortgaging":
      return <HomeAlt size={size} />;
    case "probate":
      return <HistoryEdu size={size} />;
    case "all":
      return <HomeWork size={size} />;
    default:
      console.log(`Case icon type is ${type}`);
      return null;
  }
}

export default CaseIcon;

CaseIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};
